module.exports = "https://www.gc-qa.gnp.com.mx/ef67105ec0c73efa4fdbbb5556c80eb7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carrusel-05.gif
// module id = 8073
// module chunks = 0